import { EcEnv } from '@castlery/config';
import { featureManager } from '@castlery/monorepo-features';

export const isUttEnabled = () => featureManager.isFeatureEnabled(featureManager.featureName.UTT_IMPACT);

export const getUTTCdnUrl = () => {
  if (!isUttEnabled()) return '';
  const region = EcEnv.NEXT_PUBLIC_COUNTRY;
  const upperCaseRegion = region.toUpperCase() as any;
  const uttPayload = featureManager.getFeatureFlagPayload(featureManager.featureName.UTT_IMPACT);
  if (!uttPayload) return '';

  return uttPayload[upperCaseRegion]?.scriptUrl || '';
};
